import React from 'react';
interface WhatsAppLogoProps {
  size?: number;
  className?: string;
}
export const WhatsAppLogo = ({
  size = 20,
  className = ''
}: WhatsAppLogoProps) => {
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qbSkED6h3AV2STgDHBR6m3/pngimg.com_-_whatsapp_PNG21_-_Bewerkt.png" alt="WhatsApp" width={size} height={size} className={className} style={{
    width: size,
    height: size,
    objectFit: 'contain'
  }} data-id="element-321" />;
};